import {useState, useEffect} from 'preact/hooks';

// Renders `fallback` on the server AND on the client's pre-mount pass (so
// server/client markup matches at hydration time), then swaps to `children`
// once mounted. Use for anything that touches window/document at render
// time or simply isn't SSR-safe (react-player, react-virtuoso, ...).
export function ClientOnly({children, fallback = null}) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    return mounted ? children : fallback;
}
